import { Navigate, useLocation, useNavigate } from "react-router-dom";
import InnerLayout from "../../layout/inner-layout/InnerLayout";
import PortalLayout from "../../layout/main-layout/PortalLayout";
import { getSessionData } from "../interceptors/localStorageService";
import LoadingPage from "../../shared/common/Loader";
import { Suspense } from "react";

import { useFeatures } from "../../store/context/feature-context";
import { PATH_REQUIREMENTS } from "../../shared/constants/pathRequirement";
import { usePermissions } from "../../store/context/permission-context";

const ProtectedLayout = ({ element: Component, ...rest }) => {
  const sessionData = getSessionData();
  const navigate = useNavigate();
  const location = useLocation();
  const { hasFeature } = useFeatures();
  const { hasPermission } = usePermissions();
  const isLoggedIn = !!sessionData;
  const Layout = isLoggedIn ? InnerLayout : PortalLayout;

  // feature and permission guard: if current path maps to a disabled feature, block access
  const featureCodes = PATH_REQUIREMENTS[location.pathname]?.features;
  const permissionCodes = PATH_REQUIREMENTS[location.pathname]?.permissions;

  console.log("feature and permission guard are ;", {
    featureCodes,
    permissionCodes,
  });

  const isFeatureDisabled =
    featureCodes &&
    !featureCodes.every((featureCode) => hasFeature(featureCode));
  const isPermissionDisabled =
    permissionCodes &&
    !permissionCodes.some((permissionCode) => hasPermission(permissionCode));

  if (isFeatureDisabled || isPermissionDisabled) {
    return <Navigate to={isLoggedIn ? "/dashboard" : "/"} replace />;
  }

  return (
    <Layout>
      <Suspense fallback={<LoadingPage />}>
        <Component {...rest} />
      </Suspense>
    </Layout>
  );
};

export default ProtectedLayout;
